module.exports = __webpack_public_path__ + "img/GB6.3d8f22c1.jpg";